module.exports = __webpack_public_path__ + "img/VNM.6b59b3d7.png";